import { createContext, useContext } from "react";

interface MenuStyleContextProps {
  withLastRowUnderline: boolean;
}

export const MenuStyle = createContext<MenuStyleContextProps>({ withLastRowUnderline: false });
export const useMenuStyle = (): MenuStyleContextProps => useContext<MenuStyleContextProps>(MenuStyle);
